import getLogger, { LogGroup } from "../logger";
import aiGenerationService from "../services/aiGeneration";

const logger = getLogger(LogGroup.AI);

type GenerateTeamAssetMetadataState = Partial<{
    name: string,
    altText: string,
    tags: string[],
    isGenerating: boolean,
    error: any,
}>;

export async function generateTeamAssetMetadata({
    resourceId,
    onReportState = () => {},
}: {
    resourceId: string,
    onReportState?: (state: GenerateTeamAssetMetadataState) => void,
}) {
    onReportState({ isGenerating: true, error: null });

    try {
        const { name, description, tags } = await aiGenerationService.generateTeamAssetMetadata({ resourceId });
        if (!description?.trim()) {
            throw new Error("[generateTeamAssetMetadata] Generated metadata did not include a description.");
        }

        onReportState({
            name: name?.trim() ?? "",
            altText: description.trim(),
            tags: tags ?? [],
            isGenerating: false,
        });
    } catch (error) {
        logger.error(error, "[generateTeamAssetMetadata]");
        onReportState({ isGenerating: false, error });
    }
}
